export default "__VITE_ASSET__DKNE1F8X__"